export default function CopyToClipboardButton(props: { text: string, title: string }) {
    return (
        <a href=""
            title={'Copy ' + props.title}
            style={{ color: 'unset', marginLeft: '2px' }}
            onClick={(e) => { e.preventDefault(); navigator.clipboard.writeText(props.text); }}>
            <i className="dx-icon dx-icon-copy" style={{ fontSize: 'unset' }}></i>
        </a>
    );
}
